import * as i1 from '@abp/ng.core';
import { mapEnumToOptions } from '@abp/ng.core';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

class AuditLogsService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpAuditLogging';
        this.get = (id) => this.restService.request({
            method: 'GET',
            url: `/api/audit-logging/audit-logs/${id}`,
        }, { apiName: this.apiName });
        this.getAverageExecutionDurationPerDay = (filter) => this.restService.request({
            method: 'GET',
            url: '/api/audit-logging/audit-logs/statistics/average-execution-duration-per-day',
            params: { startDate: filter.startDate, endDate: filter.endDate },
        }, { apiName: this.apiName });
        this.getEntityChange = (entityChangeId) => this.restService.request({
            method: 'GET',
            url: `/api/audit-logging/audit-logs/entity-changes/${entityChangeId}`,
        }, { apiName: this.apiName });
        this.getEntityChangeWithUsername = (entityChangeId) => this.restService.request({
            method: 'GET',
            url: `/api/audit-logging/audit-logs/entity-change-with-username/${entityChangeId}`,
        }, { apiName: this.apiName });
        this.getEntityChanges = (input) => this.restService.request({
            method: 'GET',
            url: '/api/audit-logging/audit-logs/entity-changes',
            params: { auditLogId: input.auditLogId, entityChangeType: input.entityChangeType, entityId: input.entityId, entityTypeFullName: input.entityTypeFullName, startDate: input.startDate, endDate: input.endDate, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
        }, { apiName: this.apiName });
        this.getEntityChangesWithUsername = (input) => this.restService.request({
            method: 'GET',
            url: '/api/audit-logging/audit-logs/entity-changes-with-username',
            params: { entityId: input.entityId, entityTypeFullName: input.entityTypeFullName },
        }, { apiName: this.apiName });
        this.getErrorRate = (filter) => this.restService.request({
            method: 'GET',
            url: '/api/audit-logging/audit-logs/statistics/error-rate',
            params: { startDate: filter.startDate, endDate: filter.endDate },
        }, { apiName: this.apiName });
        this.getList = (input) => this.restService.request({
            method: 'GET',
            url: '/api/audit-logging/audit-logs',
            params: { startTime: input.startTime, endTime: input.endTime, url: input.url, userName: input.userName, applicationName: input.applicationName, clientIpAddress: input.clientIpAddress, correlationId: input.correlationId, httpMethod: input.httpMethod, httpStatusCode: input.httpStatusCode, maxExecutionDuration: input.maxExecutionDuration, minExecutionDuration: input.minExecutionDuration, hasException: input.hasException, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
        }, { apiName: this.apiName });
    }
}
AuditLogsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: AuditLogsService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable });
AuditLogsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: AuditLogsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: AuditLogsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.RestService }]; } });

var EntityChangeType;
(function (EntityChangeType) {
    EntityChangeType[EntityChangeType["Created"] = 0] = "Created";
    EntityChangeType[EntityChangeType["Updated"] = 1] = "Updated";
    EntityChangeType[EntityChangeType["Deleted"] = 2] = "Deleted";
})(EntityChangeType || (EntityChangeType = {}));
const entityChangeTypeOptions = mapEnumToOptions(EntityChangeType);

/**
 * Generated bundle index. Do not edit.
 */

export { AuditLogsService, EntityChangeType, entityChangeTypeOptions };
